module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.imagesDisabled.length || _vm.variation.images.length) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "columns": 12,
      "label": "Imagens",
      "error": _vm.getErrorsBySku('images', _vm.variation.sku)
    }
  }, [_c('Container', {
    attrs: {
      "drop": _vm.onDrop,
      "orientation": "horizontal"
    },
    on: {
      "drop": _vm.onDrop
    }
  }, [_vm._l((_vm.variation.images), function(image, index) {
    return (_vm.variation.images.length) ? _c('Draggable', {
      key: image,
      staticClass: "image-list",
      model: {
        value: (_vm.variation.images),
        callback: function($$v) {
          _vm.$set(_vm.variation, "images", $$v)
        },
        expression: "variation.images"
      }
    }, [_c('div', {
      staticClass: "product-image draggable-item-horizontal"
    }, [_c('checkbox', {
      attrs: {
        "checkedDefault": true,
        "toggleChecked": _vm.toggleChecked
      },
      model: {
        value: (index),
        callback: function($$v) {
          index = $$v
        },
        expression: "index"
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": image,
        "alt": ""
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "image-list"
  }, _vm._l((_vm.imagesDisabled), function(image, index) {
    return (_vm.imagesDisabled.length) ? _c('div', {
      key: image,
      staticClass: "product-image disabled"
    }, [_c('checkbox', {
      attrs: {
        "checkedDefault": false,
        "toggleChecked": _vm.toggleChecked
      },
      model: {
        value: (index),
        callback: function($$v) {
          index = $$v
        },
        expression: "index"
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": image,
        "alt": ""
      }
    })], 1) : _vm._e()
  }), 0)], 2)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f0906c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Api/Image.vue
// module id = 2977
// module chunks = 0